import React from "react";

import ImportExportMenu from "Components/Common/DataImport/ImportExportMenu";
import { DataImportConfig } from "Components/Common/DataImport/dataImportFields";
import {
  exportCapacityAssessmentTypesToCSV,
  importCapacityAssessmentType,
} from "common/services/capacity-assessments.service";

const importConfig: DataImportConfig = {
  title: "Capacity Assessment Types",
  entityLabel: "capacity assessment type",
  icon: "ri-clipboard-line",
  templateFile: "capacity_assessment_types_import_template.csv",
  importFn: importCapacityAssessmentType,
  fields: [
    {
      key: "name",
      label: "Name",
      required: true,
      hint: "Must be unique across capacity assessment types",
    },
    { key: "description", label: "Description" },
  ],
};

/** Import/export menu for the capacity assessment types table. */
const Import = ({
  apiParams,
  onImported,
}: {
  apiParams?: any;
  onImported?: () => void;
}) => (
  <ImportExportMenu
    resource="capacity-assessment-type"
    config={importConfig}
    exportFn={exportCapacityAssessmentTypesToCSV}
    exportFileName="Capacity_Assessment_Types_Export.csv"
    apiParams={apiParams}
    onImported={onImported}
  />
);

export default Import;
